import { ojs, app } from "modular-openscriptjs";

const h = app("h");

export default function BackButton(...args) {
	return h._(
		h.button(
			h.span(h.i({ class: "bi bi-chevron-left" })),
			{
				class: "btn btn-outline-primary border-transparent",
				onclick: "app('router').back()",
			},
			...args
		)
	);
}

ojs(BackButton);
